export default __webpack_public_path__ + "static/media/derniers-min.2e002654.svg";